import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ExternalLinkIcon = React.forwardRef(function ExternalLinkIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3C15 2.44772 15.4477 2 16 2H22V8C22 8.55228 21.5523 9 21 9 20.4477 9 20 8.55228 20 8V4H16C15.4477 4 15 3.55228 15 3ZM6 4C4.90228 4 4 4.90228 4 6V18C4 19.0977 4.90228 20 6 20H18C19.0977 20 20 19.0977 20 18V16.51C20 15.9577 20.4477 15.51 21 15.51 21.5523 15.51 22 15.9577 22 16.51V18C22 20.2023 20.2023 22 18 22H6C3.79772 22 2 20.2023 2 18V6C2 3.79772 3.79772 2 6 2H8C8.55228 2 9 2.44772 9 3 9 3.55228 8.55228 4 8 4H6Z"
      ></path>
    </svg>
  )
})

ExternalLinkIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ExternalLinkIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ExternalLinkIcon
